import React from 'react';
import Footer from '@components/shared/Footer/Footer';
import OffRampPage from '@components/OffRampPage/OffRampPage';
import { useTexts } from 'utils/useTexts';

const OffRamp = () => {
  const { t } = useTexts();
  return (
    <>
      <OffRampPage />
      <Footer text={t('thankYou.footer')} />
    </>
  );
};

export default OffRamp;
